import React from 'react';
import {
  Button,
  Card,
  CardDescription,
  CardFooter,
  CardHeader,
  CardTitle,
} from '@ais-ui/ui-core';
import { cn } from '@ais-ui/utils';
import { useLocalization } from '@ais-ui/locale-management';
import { useOnMapPanelExit } from '../Map/MapPanel/useOnMapPanelExit';
import { CreateReportProvider } from './Mutations/CreateReportTemplate/CreateReportContext';
import { CreateReportTemplate } from './Mutations/CreateReportTemplate/CreateReportTemplate';
import { ReportListContent } from './ReportListContent';

interface ReportListProps {
  className: string;
}

export const ReportList = ({ className }: ReportListProps) => {
  const { messages } = useLocalization();
  const onExit = useOnMapPanelExit();

  return (
    <Card className={cn('flex flex-col', className)}>
      <CardHeader>
        <div className="space-y-2">
          <div className="flex justify-between items-center">
            <CardTitle className="text-lg font-medium text-muted-foreground">
              {messages.reportsListTitle}
            </CardTitle>
            <Button
              variant="ghost"
              size="icon"
              className="-mt-8 -mr-4"
              onClick={() => onExit()}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                aria-hidden="true"
                className="h-4 w-4"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </Button>
          </div>
          <CardDescription>{messages.reportsListSubtitle}</CardDescription>
        </div>
      </CardHeader>
      <ReportListContent />
      <CardFooter className="flex flex-grow-0 flex-col items-end min-h-52">
        <CreateReportProvider>
          <CreateReportTemplate>
            <Button id="reports-create-button">Create</Button>
          </CreateReportTemplate>
        </CreateReportProvider>
      </CardFooter>
    </Card>
  );
};
